// @ts-check
import InboundOrOutboundToggle from './InboundOrOutboundToggle';

export default InboundOrOutboundToggle;
